module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#trade-apply-store-modal"
    },
    domProps: {
      "textContent": _vm._s('新增門市申請網址')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    domProps: {
      "textContent": _vm._s('批次啟用')
    },
    on: {
      "click": function($event) {
        _vm.formType = !_vm.formType
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.select.brand),
      callback: function($$v) {
        _vm.$set(_vm.select, "brand", $$v)
      },
      expression: "select.brand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.stores,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.select.store),
      callback: function($$v) {
        _vm.$set(_vm.select, "store", $$v)
      },
      expression: "select.store"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.trade_type),
      expression: "select.trade_type"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.select, "trade_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("== 金流 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 720
    }
  }, [_vm._v("icash Pay")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.status),
      expression: "select.status"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.select, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("== 申請狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("產出網址")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("審核完成")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("已完成")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.is_enable),
      expression: "select.is_enable"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.select, "is_enable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 999
    }
  }, [_vm._v("== 啟用狀態 ==")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("未啟用")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("啟用")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto text-right"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    attrs: {
      "disabled": _vm.isDownloading
    },
    on: {
      "click": function($event) {
        return _vm.exportFile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                  下載報表\n                  "), _c('clip', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.isDownloading,
      "color": '#528BB8',
      "size": '16px'
    }
  })], 1)]), _vm._v(" "), (_vm.formType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    staticClass: "betch-btns"
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5",
    domProps: {
      "textContent": _vm._s('取消')
    },
    on: {
      "click": function($event) {
        return _vm.setBetch(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-success",
    domProps: {
      "textContent": _vm._s('啟用')
    },
    on: {
      "click": function($event) {
        return _vm.setBetch(1)
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.formType) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkBoxSelectAll),
      expression: "checkBoxSelectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkBoxSelectAll) ? _vm._i(_vm.checkBoxSelectAll, null) > -1 : (_vm.checkBoxSelectAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkBoxSelectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkBoxSelectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkBoxSelectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkBoxSelectAll = $$c
        }
      }, _vm.selectAll]
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', {}, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "w-text"
  }, [_vm._v("品牌")]), _vm._v(" "), _c('th', {
    staticClass: "w-text"
  }, [_vm._v("門市（ID）")]), _vm._v(" "), _c('th', {
    staticClass: "w-text"
  }, [_vm._v("申請狀態")]), _vm._v(" "), _c('th', {
    staticClass: "w-text"
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    staticClass: "w-url"
  }, [_vm._v("申請網址")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.list), function(item, k) {
    return _c('tr', {
      key: item.id
    }, [(_vm.formType) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selectItem),
        expression: "item.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.selectItem) ? _vm._i(item.selectItem, null) > -1 : (item.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = item.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selectItem", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(k + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.brand_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.store_name) + " (" + _vm._s(item.store_id) + ")")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: _vm.handleStatus(item.status).class
    }, [_vm._v("\n                          " + _vm._s(_vm.handleStatus(item.status).text) + "\n                        ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: _vm.handleIsEnable(item.is_enable).class
    }, [_vm._v("\n                          " + _vm._s(_vm.handleIsEnable(item.is_enable).text) + "\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-url"
    }, [_c('div', {
      staticClass: "row align-center"
    }, [_c('div', {
      staticClass: "col control-url"
    }, [_vm._v(_vm._s(item.url))]), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (item.url),
        expression: "item.url",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopy),
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onError),
        expression: "onError",
        arg: "error"
      }],
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      domProps: {
        "textContent": _vm._s('複製')
      }
    })])])])])
  }), _vm._v(" "), (!_vm.list || !_vm.list.length) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    staticClass: "center-block no-data-img",
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s('沒有符合的資料')
    }
  })])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "clickPage": _vm.paginateClickPage,
      "groupAmount": _vm.paginate.groupAmount,
      "isActive": _vm.paginateIsActive,
      "pageAmount": _vm.paginateAmount,
      "total": _vm.paginate.total
    }
  })], 1)])])])])]), _vm._v(" "), _c('nd-modal', {
    attrs: {
      "option": _vm.optionConfigApplyStoreModal
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_c('nd-trade-apply-store', {
          attrs: {
            "brands": _vm.brands,
            "getDataH": _vm.getDataH,
            "tradeType": _vm.select.trade_type
          },
          on: {
            "update:choose": _vm.updateChoose
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('nd-modal', {
    attrs: {
      "option": _vm.optionsConfCheckedBetchStore
    },
    on: {
      "trigger": _vm.trigger
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function() {
        return [_vm._v("\n      確定啟用門市？\n    ")]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "tips"
  }, [_c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                        請注意：merchant ID 若是已有設定過，會覆蓋原先設定的 ID。\n                      ")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                        請選取欲批次啟用的門市（僅有產出網址狀態無法啟用）。\n                      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6059770e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TradeSetting.vue
// module id = 2450
// module chunks = 1